var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-boxes h-4 w-4",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 16.5-4.74-2.85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7 16.5 5-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5v5.17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m17 16.5-5-3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m17 16.5 4.74-2.85"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5v5.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8 7.26 5.15"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m12 8 4.74-2.85"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5V8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/boxes.e50330b5609a7afcbbedb4788d533a44.svg";
export { ForwardRef as ReactComponent };